import { gql } from '@apollo/client';

/**
 * Signed PUT URL for a bulk CSV. Actions are declared here rather than after the
 * upload because fraud-rules-service fixes them when it mints the URL, and
 * validates the status/reason pair at that point — so a bad pair is one error
 * rather than five thousand failed rows.
 */
export const CREATE_BULK_UPLOAD = gql`
  mutation CreateBulkUpload(
    $sourceType: BulkUploadSourceType!
    $actions: [BulkActionInput!]!
    $filename: String!
    $label: String
  ) {
    createBulkUpload(
      sourceType: $sourceType
      actions: $actions
      filename: $filename
      label: $label
    ) {
      uploadUrl
      uploadToken
      contentType
      maxSizeBytes
    }
  }
`;

/**
 * Called once the PUT lands. The service reads the object back and returns what
 * it found, so the agent sees the file as the backend sees it — not as the
 * browser guessed it.
 */
export const REGISTER_BULK_UPLOAD = gql`
  mutation RegisterBulkUpload(
    $uploadToken: String!
    $sourceType: BulkUploadSourceType!
    $label: String
  ) {
    registerBulkUpload(
      uploadToken: $uploadToken
      sourceType: $sourceType
      label: $label
    ) {
      label
      filename
      contentSha256
      sizeBytes
      rowCount
      requesterId
      uploadedTz
    }
  }
`;
